/**
 * 더 보기 — 다음 페이지 카드를 받아 그리드 뒤에 이어붙인다.
 *
 * 필터가 바뀌면 결과 영역이 통째로 새 마크업으로 바뀌므로, 버튼을 붙잡아 두지 않고
 * 결과 영역에 위임한다. 지금까지 몇 페이지를 봤는지도 버튼 자신이 들고 있다
 * (data-academy-page) — 그래야 교체된 뒤 1페이지부터 다시 세어진다.
 */
const InitAcademyLoadMore = () => {
  const results = document.getElementById('academy-results');

  if (!results) {
    return;
  }

  results.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-academy-more]');

    if (!button) {
      return;
    }

    const grid = results.querySelector('.academy-grid');

    if (!grid) {
      return;
    }

    const label = button.textContent;
    const page = Number(button.dataset.academyPage || '1') + 1;

    button.disabled = true;
    button.textContent = '불러오는 중…';

    try {
      // 로그인 상태로 요청해야 관리자 카드에 관리 줄이 함께 그려진다.
      const nonce = window.qrshopAcademy?.nonce;
      const response = await fetch(`${button.dataset.academyMore}&page=${page}`, {
        headers: nonce ? { 'X-WP-Nonce': nonce } : {},
      });
      const data = await response.json();

      if (data && data.html) {
        grid.insertAdjacentHTML('beforeend', data.html);
        button.dataset.academyPage = String(page);
      }

      if (!data || !data.hasMore) {
        button.closest('.academy-more')?.remove();
        return;
      }
    } catch {
      // 네트워크 오류 — 버튼을 되살려 다시 시도할 수 있게 한다.
    }

    button.disabled = false;
    button.textContent = label;
  });
};

export default InitAcademyLoadMore;
